import { api } from "@/redux/api";

import {
	CompanyToDoProgressInfoResponse,
	CompanyToDoProgressInfoResponseSchema,
} from "@/pages/Private/pages/ToDo/ToDoList/schema/to-do";

import {
	ChangeQuestionnaireStepNumber,
	CreateQuestionnaireStep,
	FinalizeQuestionnaire,
	FinalizeQuestionnaireSchema,
	QuestionnaireArraySchema,
	QuestionnaireStep,
	QuestionnaireStepArray,
} from "../../pages/Questionnaire/schema/questionnaire";

import { RegisterRequest, RegisterRequestSchema } from "../../pages/Register/schema/register";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transformQuestionnaireStep = (step: any) => ({
	...step,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	industryIds: step.industries?.map((i: any) => i.id) ?? [],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	companySizeIds: step.companySizes?.map((c: any) => c.id) ?? [],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	companyRevenueIds: step.companyRevenues?.map((c: any) => c.id) ?? [],
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	companyBalanceIds: step.companyBalances?.map((c: any) => c.id) ?? [],
});

export const questionnaireApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getQuestionnaire: builder.query<QuestionnaireStepArray, void>({
			query: () => ({
				url: "questionnaire",
				responseSchema: QuestionnaireArraySchema,
			}),
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			transformResponse: (response: any[]) => response.map(transformQuestionnaireStep),
			providesTags: ["Questionnaire"],
		}),
		getTodosForDownload: builder.query<CompanyToDoProgressInfoResponse, { token: string }>({
			query: ({ token }) => ({
				url: `to-do/by-token/${token}`,
				responseSchema: CompanyToDoProgressInfoResponseSchema,
			}),
		}),
		finalizeQuestionnaire: builder.mutation<void, FinalizeQuestionnaire>({
			query: (body) => ({
				url: "questionnaire/finalize",
				method: "POST",
				body: {
					...body,
					termsAndConditions: true,
				},
				requestSchema: FinalizeQuestionnaireSchema,
			}),
		}),
		register: builder.mutation<void, RegisterRequest>({
			query: (body) => ({
				url: "questionnaire/finalize",
				method: "POST",
				body: {
					...body,
					termsAndConditions: true,
				},
				requestSchema: RegisterRequestSchema,
			}),
		}),
		createQuestionnaireStep: builder.mutation<QuestionnaireStep, CreateQuestionnaireStep>({
			query: (body) => ({
				url: "questionnaire",
				method: "POST",
				body,
			}),
			transformResponse: transformQuestionnaireStep,
		}),
		updateQuestionnaireStep: builder.mutation<QuestionnaireStep, QuestionnaireStep>({
			query: (body) => ({
				url: `questionnaire/${body.id}`,
				method: "PATCH",
				body,
			}),
			transformResponse: transformQuestionnaireStep,
		}),
		updateQuestionnaireStepNumber: builder.mutation<
			QuestionnaireStepArray,
			ChangeQuestionnaireStepNumber
		>({
			query: (body) => ({
				url: `questionnaire/${body.id}/step`,
				method: "PATCH",
				body: { stepNumber: body.stepNumber },
				responseSchema: QuestionnaireArraySchema,
			}),
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			transformResponse: (response: any[]) => response.map(transformQuestionnaireStep),
		}),
		deleteQuestionnaireStep: builder.mutation<QuestionnaireStepArray, number>({
			query: (id) => ({
				url: `questionnaire/${id}`,
				method: "DELETE",
				responseSchema: QuestionnaireArraySchema,
			}),
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			transformResponse: (response: any[]) => response.map(transformQuestionnaireStep),
		}),
	}),
});

export const {
	useGetQuestionnaireQuery,
	useFinalizeQuestionnaireMutation,
	useRegisterMutation,
	useCreateQuestionnaireStepMutation,
	useUpdateQuestionnaireStepMutation,
	useUpdateQuestionnaireStepNumberMutation,
	useDeleteQuestionnaireStepMutation,
	useGetTodosForDownloadQuery,
} = questionnaireApi;
export const accountApiReducer = questionnaireApi.reducer;
export const accountApiMiddleware = questionnaireApi.middleware;
